import CertificateIcon from './component.jsx'
export default CertificateIcon
